const strings = {
  'titles/banner/play/text': {
    en: 'Play',
    fr: 'Jouer',
  },
  'titles/banner/info/text': {
    en: 'Info',
    fr: 'Infos',
  },
  'titles/section/games/text': {
    en: 'TODAY’S GAMES',
    fr: 'LES MATCHS D’AUJOURD’HUI',
  },
  'titles/section/picks/text': {
    en: 'YOUR PICKS',
    fr: 'VOS CHOIX',
  },
  'titles/section/howToPlay/text': {
    en: 'How To Play',
    fr: 'Comment jouer',
  },
  'titles/section/yourPicks/text': {
    en: '<span>Your Picks</span>',
    fr: '<span>Vos choix</span>',
  },
  'titles/section/prizes/text': {
    en: 'Daily Prizes',
    fr: 'Prix quotidiens',
  },
  'titles/section/streaks/text': {
    en: 'Hot Streaks',
    fr: 'Victoires consécutives',
  },
  'titles/section/challenges/text': {
    en: 'Challenges',
    fr: 'Défis',
  },
  'titles/onboarding/quiz/text': {
    en: 'SKILL-TESTING QUESTION',
    fr: 'Question réglementaire',
  },
  'titles/onboarding/username/text': {
    en: 'DISPLAY NAME CREATION',
    fr: 'CRÉATION D’UN NOM D’AFFICHAGE',
  },
  'titles/onboarding/notifications/text': {
    en: 'NOTIFICATIONS OPT-IN',
    fr: 'ACTIVATION DES NOTIFICATIONS',
  },
  'titles/onboarding/done/text': {
    en: 'YOU’RE READY TO PLAY!',
    fr: 'C’EST L’HEURE DE JOUER!',
  },
};

export default strings;
